import {
  Injectable,
  Optional,
} from '@angular/core';
import {
  CanActivate,
  RedirectCommand,
  Router,
} from '@angular/router';
import {
  JourneyModel,
  JourneysStore,
  selectSelectedJourney,
} from '@des/store/journeys';
import {
  select,
  Store,
} from '@ngrx/store';
import {
  ConfigurationBaseService,
  ConfigurationObserver,
} from '@o3r/configuration';
import {
  REFX_COMPONENTS_SSCI_RUNTIME_CONFIG_DEFAULT,
  REFX_COMPONENTS_SSCI_RUNTIME_CONFIG_ID,
  RefxComponentsSsciRuntimeConfig,
} from '@refx/ssci-common';
import {
  combineLatest,
  Observable,
} from 'rxjs';
import {
  map,
  take,
} from 'rxjs/operators';
import {
  isJourneyEligibleForCancelation,
} from '../../app/ssci/overview/overview.helper';
import {
  SsciRoutes,
} from '../../configuration/routes';

/**
 * Check if the journey is eligible to HPBT.
 */
@Injectable()
export class CancelCheckInEligibleGuard implements CanActivate {
  /**
   * Global configuration stream
   */
  public globalConfig$: Observable<RefxComponentsSsciRuntimeConfig>;

  constructor(
    private readonly store: Store<JourneysStore>,
    private readonly router: Router,
    @Optional() configurationService?: ConfigurationBaseService
  ) {
    this.globalConfig$ = new ConfigurationObserver<any>(
      REFX_COMPONENTS_SSCI_RUNTIME_CONFIG_ID, REFX_COMPONENTS_SSCI_RUNTIME_CONFIG_DEFAULT, configurationService
    ).asObservable() as Observable<RefxComponentsSsciRuntimeConfig>;
  }

  /**
   * Check if the journey is eligible to HPBT.
   */
  public canActivate(): Observable<boolean | RedirectCommand> {
    const journeyEligible$ = this.store.pipe(
      select(selectSelectedJourney),
      take(1),
      map((journey: JourneyModel) => journey && !journey.isPending && !journey.isFailure && journey.flights[0] && isJourneyEligibleForCancelation(journey))
    );
    const checkinCancelFlowEnabled$ = this.globalConfig$.pipe(map((globalConfig) => globalConfig.globalEnableCheckinCancelFlow));

    return combineLatest(
      [
        journeyEligible$,
        checkinCancelFlowEnabled$
      ]
    ).pipe(
      take(1),
      map(([journeyEligible, checkinCancelFlowEnabled]) =>
        journeyEligible && checkinCancelFlowEnabled ? true : new RedirectCommand(this.router.parseUrl(SsciRoutes.overview), {
          replaceUrl: false
        }))
    );
  }
}
